import React, { useEffect } from 'react';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock, FaArrowUp, FaWhatsappSquare } from 'react-icons/fa';
import { IoLogoWhatsapp } from 'react-icons/io';
import { Link } from 'react-router-dom';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const handleScroll = () => {
      const backToTop = document.querySelector('.back-to-top');
      if (window.scrollY > 300) {
        backToTop.style.display = 'flex';
      } else {
        backToTop.style.display = 'none';
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <footer className="bg-gradient-to-b from-[#2C5C68] to-[#1E3A40] text-white pt-12 pb-6 px-4">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row flex-wrap gap-8 justify-between">

        {/* Company Info */}
        <div className="flex-1 min-w-[250px]">
          {/* Logo Section */}
          <div className="flex items-center mb-1">
            <img
              src="../assets/images/logo/01.svg"
              alt="Omanye FZ-LLC"
              className="h-20 md:h-28 object-contain"
            />
          </div>

          {/* Tagline */}
          <p className="text-sm font-semibold text-[#BCA033] ">
            Synergy in Exceptional Solutions
          </p>

          {/* Description */}
          <p className="text-gray-300 leading-relaxed">
            We're committed to elevating the construction experience with
            <span className="font-medium text-white"> innovation</span> and
            <span className="font-medium text-white"> quality craftsmanship</span>.
          </p>
        </div>


        {/* Quick Links */}
        <div className="flex-1 min-w-[200px]">
          <h3 className="text-[#00A3A1] text-lg font-semibold mb-4">Quick Links</h3>
          <ul className="space-y-2">
            {[
              { text: 'About Us', link: '/about-us' },
              { text: 'Projects', link: '/turnkey-projects' },
              { text: 'Terms & Conditions', link: '/terms_conditions' },
              { text: 'Contact Us', link: '/contact-us' },
              { text: "Blogs", link: '/blogs' }

            ].map((item) => (
              <li key={item.text}>
                <a
                  href={item.link}
                  className="text-[#E0F7FA]  hover:underline hover:text-teal-300 transition-colors flex items-center"
                >
                  <span className="mr-2 text-[#AEDEE0]">→</span> {item.text}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div className="flex-1 min-w-[200px]">
          <h3 className="text-[#00A3A1] text-lg font-semibold mb-4">Our Services</h3>
          <ul className="space-y-2">
            {[
              { name: "Green Construction", path: "/green-construction" },
              { name: "BMC Services", path: "/bmc-services" },
              { name: "Construction Services", path: "/construction-services" },
              { name: "Hassle-Free Procurement", path: "/hassle-free-procurement" },
              { name: "Post Construction", path: "/post-construction" },
              { name: "Global Expansion", path: "/global-expansion" },
              { name: "Turnkey Projects", path: "/turnkey-projects" },
            ].map((service) => (
              <li key={service.path}>
                <Link
                  to={service.path}
                  className="text-[#E0F7FA] flex items-center hover:underline hover:text-teal-300 transition-colors"
                >
                  {service.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Info */}
        <div className="flex-1 min-w-[250px]">
          <h3 className="text-[#00A3A1] text-lg font-semibold mb-4">Contact Us</h3>
          <ul className="space-y-3">
            <li className="flex items-start">
              <FaMapMarkerAlt className="text-[#AEDEE0] mt-1 mr-3 flex-shrink-0" />
              <span className="text-[#E0F7FA] text-sm leading-relaxed">
                FOB 51927 Compass Building, Al Shohoda Road, Al Hamra Industrial Zone-FZ, Ras Al Khaimah, UAE
              </span>
            </li>

            <li className="flex items-center">
              <IoLogoWhatsapp className="text-green-500 mr-2 text-xl flex-shrink-0" />
              <a
                href="https://wa.me/971503118846?text=Hello%2C%20I%27m%20interested%20in%20your%20gems"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#E0F7FA] hover:text-green-400 text-sm"
              >
               +971 50 311 8846
              </a>

            </li>


            <li className="flex items-center">
              <FaEnvelope className="text-[#AEDEE0] mr-3" />
              <span className="text-[#E0F7FA]">gbd@omanyefz.com</span>
            </li>
            <li className="flex items-center">
              <FaEnvelope className="text-[#AEDEE0] mr-3" />
              <span className="text-[#E0F7FA]">gbd.omanyefz@gmail.com</span>
            </li>

            <li className="flex items-center">
              <FaClock className="text-[#AEDEE0] mr-3" />
              <span className="text-[#E0F7FA]">
                Mon-Fri: 9:00 am - 5:00 pm<br />
                Sat: 9:00 am - 2:00 pm
              </span>
            </li>
          </ul>
        </div>
      </div>

      {/* Copyright Section */}
      <p className="text-[#00A3A1] text-center my-3 font-semibold mb-4 md:mb-0">
        &copy; {new Date().getFullYear()} Omanye FZ-LLC. All rights reserved.
      </p>


      {/* Back to Top Button */}
      <button
        onClick={scrollToTop}
        className="back-to-top fixed bottom-8 right-8 bg-[#3A7A88] text-white p-3 rounded-full shadow-lg hover:bg-[#4A9AAA] transition-colors hidden items-center justify-center"
        style={{ zIndex: 999 }}
      >
        <FaArrowUp size={20} />
      </button>
    </footer>
  );
};

export default Footer;